import React, {useEffect, useState} from 'react'
import { KTSVG, toAbsoluteUrl } from '_metronic/helpers'
import { AccountLimitModel } from 'app/modules/setting/models/Account'
import {useDispatch} from 'react-redux'
import {actions} from '../../redux/AccountRedux'
import moment from 'moment'
import {date} from "yup";
import {round} from "@popperjs/core/lib/utils/math";
type Props = {
    item: AccountLimitModel,
    index:number
}
function format1(n:number) {
    return n.toFixed(0).replace(/./g, function(c, i, a) {
        return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
    });
}
const UserItemLimit : React.FC<Props> = ({ item ,index}) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const clickHandler =()=>{
        dispatch(actions.showCurrentAccountLimit(item))
    }
    return (

        <tr>
            <td>
                <span>
                    <text style={{fontSize:12,fontWeight:"bold"}} >
                    {item.user}
                    </text>
                </span>

            </td>
            <td >
                    <span style={{fontSize:11}} >
                                <text style={{fontWeight:"bold"}} >
                                        {item.service}
                                </text>
                    </span>
            </td>
            <td >
                    <span style={{fontSize:12}} >
                                <text style={{fontWeight:"bold"}} >
                                        {item.maxorder}
                                </text>
                    </span>
                <span style={{ color:'white',fontSize:10,backgroundColor:"rgba(20,122,178,0.66)",marginLeft:5,padding:2}} className='badge badge-success 1'>{item.countorder}</span>
            </td>
            <td >
                    <span style={{fontSize:12}} >
                                <text style={{fontWeight:"bold"}} >
                                        {item.maxrunning}
                                </text>
                    </span>
                <span style={{ color:'white',fontSize:10,backgroundColor:"#03d96e",marginLeft:5,padding:2}} className='badge badge-success 1'>{item.countdone}</span>
            </td>
            <td>
                <div className='d-flex justify-content-end flex-shrink-0'>
                    <button
                        onClick={()=>clickHandler()}
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    >
                        <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                    </button>
                </div>
            </td>
        </tr>
    )
}

export default UserItemLimit